import React, { PropTypes as p } from 'react'
import moment from 'moment'

import { Badge } from '../data-card/data-card-parts'

import pinStatusColors from '../../helpers/pin-status-colors'
import pinStatus from '../../helpers/pin-status'

const PinPreview = ({
  pin,
  area,
  active,
  ...rest
}) => (
  <div className={`pin-preview ${active ? 'active' : ''}`} {...rest}>
    <header>
      <p className='room'>{area.name}</p>
      <Badge text={pinStatus(pin.status)} color={pinStatusColors[pin.status]} />
    </header>

    {pin.latestHistory && pin.latestHistory.createdAt
      ? (<p>Updated {pin.latestHistory.createdAt.format('MMMM Do, YYYY')}</p>)
      : 'Never updated'
    }
  </div>
)

PinPreview.propTypes = {
  pin: p.shape({
    status: p.string,
    updatedAt: p.instanceOf(moment)
  }),
  area: p.shape({ name: p.string.isRequired }).isRequired
}

export default PinPreview



// WEBPACK FOOTER //
// ./src/components/pins/pin-preview.js